<template>
    <div class="fund-small-card-item bgClass"
        :style="style4Obj"
        :class="{
            'hkd': isHKD,
            'sgd': isSGD,
            'usd': isUSD,
            'is-en': lang === 'EN',
        }"
    >
        <!-- 类型4 -->
        <div class="type-1 type-4" @click="jumpToFutunn">
            <h5>
                <strong v-if="!tags.length" class="market">
                    {{ market }}
                </strong>
                <span>{{ name }}</span>
            </h5>
            <ul v-if="tags.length" class="flagList">
                <li>{{ market }}</li>
                <li
                    v-for="(item, index) in tags"
                    v-bind:key="index"
                    class="tag"
                >
                    {{ item }}
                </li>
            </ul>
            <div class="gain">
                <!-- <p class="data" :class="{
                    'green': isFall(increaseHkd)
                }"> -->
                <p class="data" :style="{color: dataColor+ '!important'}">
                    <span v-if="isFall(increaseHkd)">{{increaseHkd}}</span>
                    <template v-else>
                        <span class="plus">+</span>{{increaseHkd}}
                    </template>
                </p>

                <span class="des">
                   {{fundInfo.increaseTag}}
                </span>
            </div>
            <div class="arrow"></div>
        </div>

    </div>
</template>

<script>
import Toast from "@futuweb/future-ui/es/toast";
import "@futuweb/future-ui/es/toast/style/index.css";
import { INCREASEENUM, typeMapApiName } from './util';
import { isMoomoo, isNN, laterThanVersion } from '@futuweb/tool-browser';
import request from '../assets/scripts/request';
import NNQ from '@futuweb/tool-nn/dist/nnq';

const {
    common: {
        utils: { jumpSchema, launchNN, launchMM},
        report: { record },
        request: { get }
    }
} = window.FEGORender;
export default {
    name: "fund-small-card-item",
    props: {
        // 公共部分
        NewCode: {
            type: String
        },
        name: {
            type: String
        },
        highlight: {
            type: String
        },
        lang: {
            type: String,
            default: "CN"
        },
        borderColor: {
            type: String
        },
        bgColor: {
            type: String
        },
        defaultType: {
            type: String,
            default: 'usd'
        },
        increaseType: {
            type: String,
            default: '4'
        },
        followApp: {
            type: Boolean,
            default: true
        },
        riseColor: {
            type: String
        },
        fallColor: {
            type: String
        }
    },
    data() {
        return {
            increaseHkd: '0.00%',
            // 客户端涨跌色类型
            upDownType: -1,
            isMM: isMoomoo()
        };
    },
    created() {},
    computed: {
        tags() {
            return this.highlight.length > 0 ? this.highlight.split("/") : [];
        },
        style4Obj() {
            return {
                backgroundColor: this.bgColor,
                borderColor: this.borderColor
            }
        },
        isHKD() {
            return this.defaultType === 'hkd';
        },
        isSGD() {
            return this.defaultType === 'sgd';
        },
        isUSD() {
            return this.defaultType === 'usd';
        },
        fundInfo() {
            const key = this.lang === 'CN' ? 'tag' : (this.lang === 'HK' ? 'tagHk' : 'tagEn');
            return {
                newCode: this.NewCode,
                increaseType: this.increaseType,
                increaseTag: this.increaseType ? INCREASEENUM[this.increaseType][key] : ''
            };
        },
        dataColor() {
            const increaseHkd = parseFloat(this.increaseHkd) || 0;

            const grey = '#677DA1';
            const red = '#F13E3A';
            const green = '#00A843';
            const pink = '#F03A55';

            if (increaseHkd === 0) {
                return grey;
            }

            if (this.upDownType === 0) {
                // 0-红涨绿跌
                return increaseHkd > 0 ? red : green;
            } else if (this.upDownType === 1) {
                // 1-绿涨红跌
                return increaseHkd > 0 ? green : red;
            } else if (this.upDownType === 2) {
                // 2-色盲色涨色（粉涨绿跌）
                return increaseHkd > 0 ? pink : green;
            } else if (this.upDownType === 3) {
                // 3-色盲色跌色（绿涨粉跌）
                return increaseHkd > 0 ? green : pink;
            }

            // 未命中 upDownType 则使用 fego 配置的颜色
            return increaseHkd > 0 ? this.riseColor : this.fallColor;
        },
        market() {
            return this.defaultType.toUpperCase();
        }
    },
    methods: {
        async initData() {
            try {
                if (this.fundInfo.newCode && this.fundInfo.increaseType) {
                    const commonApiRequest = request.bindCommonApi('fund-small-card-item');
                    const ret = await commonApiRequest.get(typeMapApiName[this.fundInfo.increaseType], {
                        code: this.fundInfo.newCode
                    });
                    this.increaseHkd = ret;
                }
            } catch (e) {
                console.log(e);
                this.increaseHkd = '0.00%';
                const tips = this.lang === 'CN' ? '基金净值加载失败' : '基金淨值加載失敗';
                Toast.fail(tips, 2);
            }
        },
        jumpToFutunn($event) {
            const obj = { button_name: this.NewCode, $element_name: this.NewCode };
            record($event, obj);
            const hostname = window.location.hostname;
            if (this.isMM || hostname.indexOf('moomoo.com') > -1) {
                launchMM(`ftmm://quote/stockDetail/${this.NewCode}/1/`);
            } else {
                launchNN(`ftnn://quote/stockDetail/${this.NewCode}/1/`);
            }
        },
        isFall(rate = '') {
            return rate.indexOf('-') !== -1;
        },
        // 初始化牛牛NNWebViewJSBridge
        initBridge() {
            const me = this;
            NNQ.initBridge({}, () => {
                window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
                    try {
                        // result: 0 成功， -1失败
                        const ret = JSON.parse(res);
                        if (ret && ret.result === 0) {
                            //data: 涨跌色，0红涨绿跌，1绿涨红跌，2色盲色涨色（粉涨绿跌），3色盲色跌色（绿涨粉跌）
                            me.upDownType = ret.data;
                        }
                    } catch (e) {
                        console.error(e);
                    }
                });
            });
        },
    },
    mounted() {
        this.initData();
        // 设置了跟随客户端涨跌色，且客户端版本支持，则通过 jsbridge 去获取客户端涨跌色类型
        if (this.followApp && isNN() && !laterThanVersion('12.43.8908')) {
            this.initBridge();
        }
    }
};
</script>
<style lang="less" scoped>
.fund-small-card-item {
    background-color: #FFFFFF;
    &.is-en {
        font-family: 'BR Hendrix';
    }
    .flagList {
        margin-top: 0.17rem;
        display: flex;
        color: #7a7a7a;
        color: #999;
        font-size: 0.24rem;
        width: 120%;
        transform: scale(0.82);
        transform-origin: left top;
        li {
            box-sizing: border-box;
            border: .02rem solid #999;
            height: 0.43rem;
            line-height: .43rem;
            border-radius: 0.06rem;
            margin-right: 0.16rem;
            padding: 0 0.1rem;
            overflow: hidden;
            word-break: break-all;
        }
    }
    .type-1 {
        h5 {
            font-weight: 550;
            font-size: 0.32rem;
            line-height: 0.45rem;
            color: #000;
            display: flex;
            align-items: center;
            .market {
                display: block;
                transform: scale(0.82);
                height: 0.43rem;
                line-height: .43rem;
                border-radius: 0.06rem;
                padding: 0 0.1rem;
                font-size: 0.24rem;
                border: .02rem solid #999;
                color: #999;
                transform-origin: left center;
            }
            span {
                display: inline-block;
                max-width: 5.5rem;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        h5:before {
            content: "";
            display: none;
            height: 0.32rem;
            width: 0.55rem;
            background: url("https://static.futunn.com/upload/icon-hkd-38f57d79b276c433d7d2116f74ad9e58.png?_=1619168088188");
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position: left center;
            margin-right: 0.12rem;
        }
        .gain {
            margin-top: 0.2rem;
            .data {
                display: inline-block;
                font-family: BRMedium;
                font-size: 0.56rem;
                line-height: 0.78rem;
                color: #f13e3a;
                .plus {
                    position: relative;
                    bottom: 0.05rem;
                }
            }
            .des {
                font-size: 0.24rem;
                line-height: 0.34rem;
                color: #999999;
            }
        }
    }

    .type-2 {
        .line {
            margin: 0.13rem 0 0.29rem;
            height: 0.01rem;
            background-color: #eeeeee;
            content: "";
        }
        .des2 {
            font-size: 0.24rem;
            line-height: 160%;
            color: #959595;
        }
    }

    .type-3 {
        h5 {
            font-weight: 550;
            font-size: 0.26rem;
            line-height: 0.36rem;
            color: #494949;
            display: flex;
            align-items: center;
        }
        h5:before {
            content: "";
            display: inline-block;
            width: 0.36rem;
            height: 0.21rem;
            background: url("https://static.futunn.com/upload/icon-hkd-38f57d79b276c433d7d2116f74ad9e58.png?_=1619168088188");
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-position: left center;
            margin-right: 0.06rem;
        }
        .content {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            .gain {
                width: 1.33rem;
                .data {
                    font-weight: 600;
                    font-size: 0.36rem;
                    line-height: 0.5rem;
                    color: #f13e3a;
                    margin-bottom: 0.1rem;
                }
                .des {
                    font-size: 0.22rem;
                    line-height: 0.31rem;
                    color: #999999;
                }
            }
            .txt {
                width: 3.15rem;
                .flagList {
                    margin-top: 0.21rem;
                    font-size: 0.18rem;
                    transform: scale(0.81);
                }
            }
            .btn {
                width: 1.28rem;
                height: 0.6rem;
                line-height: 0.6rem;
                font-size: 0.24rem;
                text-align: center;
                font-weight: 600;
                color: #ffffff;
                left: 5.52rem;
                top: 5.12rem;
                background: #f13e3a;
                border-radius: 0.43rem;
            }
        }
    }
}
.green {
    color: #00a843 !important;
}
.usd {
    .type-1 {
        h5:before {
            background-repeat: no-repeat;
            background-size: auto 100% !important;
            background-position: left center;
            background: url("https://static.futunn.com/upload/icon-usd-9730ea08b6c0b91b06e4fb1ee6cfcce2.png?_=1619168088188");
        }
    }
}
.sgd {
    .type-1 {
        h5:before {
            background-repeat: no-repeat;
            background-size: auto 100% !important;
            background-position: left center;
            background: url("https://fegostatic.moomoo.com/images/2022062200006684517beb1cc0e.png");
        }
    }
}
.bgClass {
    border-width: 0.02rem;
    border-style: solid;
    .type-4 {
        position: relative;
        .arrow {
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            width: .17rem;
            height: .25rem;
            background-repeat: no-repeat;
            background-size: auto 100%;
            background-image: url('https://fegostatic.futunn.com/images/20220408000045051e50c049883.png');
        }
    }
}
</style>
